export default __webpack_public_path__ + "static/media/Desapedia-01.bf6db88a.png";